<template>
  <v-layout
    row
    fluid
    wrap
    class="pt-4"
  >
    <v-flex xs12 px-0 class="rounded-3">
      <v-layout class="pb-1">
        <v-flex grow>
          <h2 class="pt-2 text-truncate text-align-left primary--text">
            {{ dashboardSection.name }}
          </h2>
        </v-flex>
        <v-flex shrink>
          <v-menu
            nudge-top="30px"
            left
            offset-y
            origin="center center"
            transition="scale-transition"
          >
            <v-btn
              flat
              slot="activator"
              icon
              class="ma-0 mr-0 pa-0"
              dark
              color="secondary"
            >
              <v-icon>more_vert</v-icon>
            </v-btn>

            <v-list dense>
              <v-list-tile @click="sectionDialog = true">
                <v-icon class="mr-2" color="secondary">settings</v-icon>Configure Section
              </v-list-tile>
              <v-list-tile @click.stop="showDeleteDialog = true">
                <v-icon class="mr-2" color="secondary">delete</v-icon>Delete Section
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
      </v-layout>
      <v-divider class="mb-0"></v-divider>
    </v-flex>

    <v-layout row fluid wrap class="pt-4" :class="{ 'pb-4': !layoutMode && !dashboardSection.widgets.length }">
      <draggable
        style="width: 100%; flex-wrap: wrap; display: flex;"
        class="dashboard-section-list"
        :class="{ 'dashboard-section-list-placeholder': layoutMode }"
        :list="dashboardSection.widgets"
        group="widgets"
        @change="widgetMoved(dashboardSection.id, $event)"
        :ghost="true"
        :disabled="!layoutMode"
      >
        <v-flex
          class="pa-1"
          :class="widgetWidth(metricWidget)"
          v-for="(metricWidget, index) in dashboardSection.widgets"
          :key="metricWidget.id"
        >
          <component
            :index="index"
            :position="index"
            :is="getComponent(metricWidget.type)"
            :metricWidget="metricWidget"
            :layout-mode="layoutMode"
            v-on:fullscreen="goFullScreen"
          />
        </v-flex>
      </draggable>
    </v-layout>
    <add-dashboard-section-dialog
      :dashboardSection="dashboardSection"
      :sectionDialog="sectionDialog"
      v-on:new-section-cancelled="closeSectionForm()"
      v-on:new-section-added="closeSectionForm()"
    ></add-dashboard-section-dialog>

    <confirmation-dialog
      title="Delete Dashboard Section"
      message="Are you sure you want to delete this section? The underlying widgets and data won't be deleted."
      confirmButtonLabel="Yes, delete this section"
      :showDialog="showDeleteDialog"
      v-on:confirm="deleteSection()"
      v-on:cancel="showDeleteDialog = false"
    ></confirmation-dialog>
  </v-layout>
</template>

<script>
import NumberWidget from "@/components/metrics/NumberWidget.vue"
import TrendlineWidget from "@/components/metrics/TrendlineWidget.vue"
import PiechartWidget from "@/components/metrics/PiechartWidget.vue"
import FullScreenWidget from "@/components/metrics/FullScreenWidget.vue"
import AddDashboardSectionDialog from "@/components/metrics/AddDashboardSectionDialog.vue"
import ConfirmationDialog from "@/components/shared/ConfirmationDialog.vue"
import draggable from "vuedraggable"

export default {
  name: "metrics-dashboard-section",
  props: ['dashboardSection', 'layoutMode'],
  components: {
    NumberWidget,
    TrendlineWidget,
    PiechartWidget,
    FullScreenWidget,
    draggable,
    AddDashboardSectionDialog,
    ConfirmationDialog
  },
  methods: {
    getComponent(component) {
      switch (component) {
        case "number":
          return NumberWidget
        case "trend":
          return TrendlineWidget
        case "piechart":
          return PiechartWidget
      }
    },
    widgetWidth(metricWidget) {
      let widthCols = 4
      if (metricWidget && metricWidget.width) {
        widthCols = metricWidget.width * 4
      }
      return `xs${widthCols} sm${widthCols} md${widthCols} lg${widthCols} xl${widthCols}`
    },
    widgetMoved(dashboardSectionId, e) {
      if (e && e.added && e.added.element && e.added.element.id) {
        e.added.element.dashboardSectionId = dashboardSectionId
        this.$store.dispatch("updateWidget", e.added.element)
      }
      if ((e && e.added) || (e && e.moved)) {
        this.$store.dispatch('reorderWidgets')
      }
    },
    closeSectionForm() {
      this.sectionDialog = false
    },
    deleteSection() {
      this.showDeleteDialog = false
      this.$store.dispatch("deleteDashboardSection", this.dashboardSection.id)
    },
    goFullScreen(widget) {
      this.$emit('fullscreen', widget)
    }
  },
  data: () => ({
    sectionDialog: false,
    showDeleteDialog: false
  })
}
</script>
<style scoped>
.dashboard-section-list:empty:before {
  content: "Select 'Change Layout' to drag a widget onto this section.";
}
.dashboard-section-list-placeholder {
  min-height: 192px;
}
</style>
